/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPilcrow = createReactComponent("pilcrow", "IconPilcrow", [
  ["path", { d: "M13 4v16", key: "svg-0" }],
  ["path", { d: "M17 4v16", key: "svg-1" }],
  ["path", { d: "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5", key: "svg-2" }]
]);

export { IconPilcrow as default };
//# sourceMappingURL=IconPilcrow.js.map
